import { SharedKeys } from "@/types/util";

export function capitalizeFirstLetter(str: string): string {
  if (!str) return str; // handle empty string
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function getErrorMessage(error: unknown) {
  if (error && typeof error === "object" && "message" in error)
    return error.message as string;
  else return "Please try again later.";
}

export function getFriendlyDateTime(dt?: string) {
  if (!dt) return "Unknown";
  return new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  }).format(new Date(dt));
}

export function getPromiseSettledValues<T>(
  promiseSettledResult: PromiseSettledResult<T | undefined>
) {
  if (promiseSettledResult.status === "fulfilled") {
    return promiseSettledResult.value as T;
  }
}

export function getTimestampForFilename() {
  const now = new Date();

  const pad = (n: number) => n.toString().padStart(2, "0");

  const year = now.getFullYear();
  const month = pad(now.getMonth() + 1);
  const day = pad(now.getDate());
  const hour = pad(now.getHours());
  const minute = pad(now.getMinutes());
  const second = pad(now.getSeconds());

  return `${year}${month}${day}_${hour}${minute}${second}`;
}

export function isGuid(value: string) {
  const guidRegex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  return guidRegex.test(value);
}

export function getSharedProperties<T extends object, U>(obj: T): U {
  const keys = Object.keys(obj) as SharedKeys<T, U>[];
  return Object.fromEntries(keys.map((key) => [key, obj[key as keyof T]])) as U;
}
